import { extendTheme } from '@chakra-ui/react';
import { mobileSafariTheme } from '@bofrak-backend/shared-ui';

const theme = extendTheme(
  {
    colors: {
      brand: {
        50: '#e6f2ff',
        100: '#b3d9ff',
        200: '#80bfff',
        300: '#4da6ff',
        400: '#1a8cff',
        500: '#0073e6',
        600: '#005bb3',
        700: '#004280',
        800: '#002a4d',
        900: '#00121a',
      },
      accent: {
        50: '#fff0e6',
        100: '#ffd4b3',
        200: '#ffb880',
        300: '#ff9c4d',
        400: '#ff801a',
        500: '#e66700',
        600: '#b35000',
        700: '#803900',
        800: '#4d2200',
        900: '#1a0b00',
      },
    },
    fonts: {
      heading: `'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif`,
      body: `'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif`,
    },
    config: {
      initialColorMode: 'light',
      useSystemColorMode: false,
    },
  },
  mobileSafariTheme,
);

export default theme;
